import { useState, useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const contentCache = {};

export function useContent(page) {
  const { language } = useLanguage();
  const cacheKey = `${language}:${page}`;

  const [content, setContent] = useState(contentCache[cacheKey] || null);
  const [loading, setLoading] = useState(!contentCache[cacheKey]);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (contentCache[cacheKey]) {
      setContent(contentCache[cacheKey]);
      setLoading(false);
      return;
    }

    const loadContent = async () => {
      try {
        setLoading(true);
        setContent(null);
        const response = await fetch(`/content/${language}/${page}.json`);

        if (!response.ok) {
          throw new Error(`Erreur de chargement du contenu: ${response.status}`);
        }

        const data = await response.json();
        contentCache[cacheKey] = data;
        setContent(data);
        setError(null);
      } catch (err) {
        console.error(`Erreur lors du chargement de ${page}.json:`, err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    loadContent();
  }, [cacheKey, language, page]);

  return { content, loading, error };
}
